import fetchGuideCollections from 'actions/guide_performance/fetch_guide_collections';
import isFeatureEnabled from 'actions/lib/is_feature_enabled';
import UserLogin from 'models/location/user_login';
import { OrganizationType } from 'models/organization';
import { ComplianceAdminRole, SystemAdminRole, TeamManagerRole } from 'models/role';
import OrganizationConverter from 'scripts/application/dto_converters/organization_converter';
import { NotExistError } from 'scripts/application/lib/error';
import { handleCommonErrors } from 'scripts/application/lib/gateway_error_silent_handler';
import analytics from 'scripts/lib/analytics';

const STANDALONE_REDIRECT_ROLE_IDS = [SystemAdminRole.id, ComplianceAdminRole.id, TeamManagerRole.id];

export default class RequestOrganization {
  constructor(context) {
    this.context = context;
  }

  run() {
    const { auth, organization: organizationStore } = this.context.stores;
    const { organizations } = this.context.gateways;

    const orgId = auth.get().getOrgId();
    organizationStore.setLoading();

    let redirected = false;

    return organizations
      .fetch({ orgId })
      .then(dto => {
        const organization = OrganizationConverter.fromDto(dto);
        organizationStore.set(organization);
        analytics.updateUser({ loginDomain: organization.loginDomain });

        if (this.redirectStandaloneOrg(organization)) {
          redirected = true;
          return;
        }

        return this.updateSidekickStatus(organization);
      })
      .then(() => {
        if (redirected) return;
        fetchGuideCollections(this.context);
      })
      .catch(err => {
        handleCommonErrors(this.context, err);
      })
      .finally(() => {
        organizationStore.resetLoading();
      });
  }

  redirectStandaloneOrg(organization) {
    if (organization.type !== OrganizationType.STANDALONE) {
      return false;
    }

    const currentLocation = this.context.stores.currentLocation.get();
    const isLoginFlow = currentLocation instanceof UserLogin || currentLocation.isFromSso;

    if (!isLoginFlow || !this.hasStandaloneRedirectRole()) {
      return false;
    }

    this.context.router.navigateToPath('/sidekick/communication-sessions');
    return true;
  }

  hasStandaloneRedirectRole() {
    const roleIds = this.context.stores.auth.get().getRoleIds() || [];
    return roleIds.some(id => STANDALONE_REDIRECT_ROLE_IDS.includes(id));
  }

  updateSidekickStatus(organization) {
    if (!isFeatureEnabled(this.context, 'viewGuidePerformance') && !isFeatureEnabled(this.context, 'answers:admin')) {
      return;
    }

    const { organization: organizationStore } = this.context.stores;
    const { sidekickOrganization: gateway } = this.context.gateways;

    return gateway
      .fetch()
      .then(() => {
        organization.setSidekickEnabled(true);
        organizationStore.set(organization);
      })
      .catch(err => {
        if (!(err instanceof NotExistError)) {
          throw err;
        }
      });
  }
}
